import { useEffect, useState, createContext, useContext } from "react";
import { media } from "../../assets/media";

const isImage = (src) => /\.(jpe?g|png)$/i.test(src);

const loadImage = (src, onLoad) => {
  const img = new window.Image();
  img.src = src;
  img.onload = onLoad;
  img.onerror = onLoad;
};

const PreloadContext = createContext({ isFontsReady: false, isMediaReady: false });
export const usePreload = () => useContext(PreloadContext);

export const PreloadProvider = ({ children }) => {
  const [progress, setProgress] = useState(0);
  const [isFontsReady, setIsFontsReady] = useState(false);
  const [isMediaReady, setIsMediaReady] = useState(false);

  useEffect(() => {
    Promise.all([
      document.fonts.ready,
      new Promise((resolve) => setTimeout(resolve, 500)),
    ]).then(() => setIsFontsReady(true));

    const sources = Object.values(media);
    const totalFiles = sources.length;
    let loaded = 0;

    const handleFileLoaded = () => {
      loaded = Math.min(loaded + 1, totalFiles);
      setProgress((loaded / totalFiles) * 100);
      if (loaded === totalFiles) {
        setIsMediaReady(true);
      }
    };

    sources.forEach((src) => {
      if (!src) return handleFileLoaded();
      if (isImage(src)) loadImage(src, handleFileLoaded);
      else handleFileLoaded();
    });
  }, []);

  return (
    <PreloadContext.Provider value={{ isFontsReady, isMediaReady }}>
      {!isFontsReady && (
        <div className="loading-screen">
          <div className="progress-bar">
            <div
              className="progress"
              style={{ width: `${Math.min(progress, 100)}%` }}
            />
          </div>
          <p>Loading... {Math.round(Math.min(progress, 100))}%</p>
        </div>
      )}
      {isFontsReady && children}
    </PreloadContext.Provider>
  );
};
